import React, { useState } from 'react';

const AzureFAQSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

const faqs = [
  {
    id: 1,
    question: 'How long does an Azure-to-Hetzner migration typically take?',
    answer: 'Migration timelines depend on the size and complexity of your Azure environment. Small infrastructures can often be migrated within 1–2 weeks, while larger environments with multiple applications, databases, and services may require 4–8 weeks.'
  },
  {
    id: 2,
    question: 'Will there be downtime during the Azure-to-Hetzner migration?',
    answer: 'We carefully plan and execute migrations to minimize downtime. In many cases, services can be migrated during maintenance windows to reduce disruption to business operations.'
  },
  {
    id: 3,
    question: 'Can existing Azure virtual machines be migrated to Hetzner Cloud?',
    answer: 'Yes. Azure virtual machines can be migrated to Hetzner Cloud servers. We assess your workloads and ensure the target infrastructure is properly configured before migration.'
  },
  {
    id: 4,
    question: 'Can Azure databases be migrated to Hetzner?',
    answer: 'Yes. We support migration of MySQL, PostgreSQL, MariaDB, SQL Server, and other database systems while maintaining data integrity and minimizing downtime.'
  },
  {
    id: 5,
    question: 'What are the benefits of moving from Azure to Hetzner?',
    answer: 'Many businesses migrate to Hetzner to reduce cloud costs, simplify infrastructure management, improve pricing predictability, and gain greater control over their hosting environment.'
  },
  {
    id: 6,
    question: 'How do you ensure data security during migration?',
    answer: 'We use encrypted data transfers, secure access controls, backup strategies, and industry best practices to protect your data throughout the migration process.'
  },
  {
    id: 7,
    question: 'Can Azure storage be migrated to Hetzner Object Storage?',
    answer: 'Yes. We can migrate Azure Blob Storage and other storage solutions to Hetzner Object Storage while preserving data integrity and accessibility.'
  },
  {
    id: 8,
    question: 'What happens after the migration is completed?',
    answer: 'After migration, we perform testing, validation, performance optimization, and provide ongoing support to ensure your environment operates smoothly.'
  },
  {
    id: 9,
    question: 'Can networking and security configurations be migrated?',
    answer: 'Yes. Firewall rules, VPN connections, load balancers, DNS settings, and other networking configurations can be recreated and optimized on the new infrastructure.'
  },
  {
    id: 10,
    question: 'Do you provide managed services after migration?',
    answer: 'Yes. We offer ongoing server management, monitoring, updates, security hardening, backup management, and infrastructure support after migration.'
  },
  {
    id: 11,
    question: 'Can applications be migrated without code changes?',
    answer: 'In many cases, applications can be migrated with little or no code modification. We analyze application dependencies and recommend adjustments only when necessary.'
  },
  {
    id: 12,
    question: 'Will user accounts and permissions be preserved?',
    answer: 'Yes. User access controls, roles, permissions, and security policies can be migrated and validated as part of the migration process.'
  },
  {
    id: 13,
    question: 'How do I get started with an Azure-to-Hetzner migration?',
    answer: 'Contact our team for a free consultation. We will assess your Azure environment, discuss your requirements, and create a customized migration plan tailored to your business needs.'
  }
];  
  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className=" py-8">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Header Section */}
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
            Azure Migration Questions
          </h2>
          <div className="accent-line w-16 h-1 bg-green-500 mx-auto mb-4"></div>
          <p className="text-base md:text-lg text-gray-600">
            Helpful answers to common migration concerns and requirements
          </p>
        </div>
        
        {/* FAQ Accordion */}
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div 
              key={faq.id}
              className="rounded-lg border overflow-hidden bg-white border-gray-200 hover:border-blue-500 transition-colors duration-300"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-6 py-4 text-left flex items-center justify-between gap-4 hover:bg-gray-50 transition-colors"
                aria-expanded={openIndex === index}
              >
                <h3 className="text-base md:text-lg font-semibold text-gray-900 pr-4">
                  {faq.question}
                </h3>
                <svg 
                  xmlns="http://www.w3.org/2000/svg" 
                  fill="none" 
                  viewBox="0 0 24 24" 
                  strokeWidth="1.5" 
                  stroke="currentColor" 
                  className="w-5 h-5 text-gray-500 flex-shrink-0 transition-transform duration-300"
                  style={{ transform: openIndex === index ? 'rotate(180deg)' : 'rotate(0deg)' }}
                >
                  <path strokeLinecap="round" strokeLinejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
                </svg>
              </button>
              
              {openIndex === index && (
                <div className="px-6 pb-4 pt-2">
                  <p className="text-sm md:text-base text-gray-700 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
        
      </div>
    </div>
  );
};

export default AzureFAQSection;